export const UNIT_APPLIANCES = {
  FRIDGE: "fridge",
  STOVE: "stove",
  RANGEHOOD: "rangehood",
  DISHWASHER: "dishwasher",
  MICROWAVE: "microwave",
  IN_UNIT_WASHER: "inunitwasher",
  IN_UNIT_DRYER: "inunitdryer",
  WINE_FRIDGE: "wineFridge",
  DEHUMIDIFIER: "dehumidifier",
  FIREPLACE_ELECTRIC: "firePlaceElectric",
  FIREPLACE_GAS: "firePlaceGas",
  JACUZZI: "jacuzzi"
}

export const Unit_Appliances = [
  { name: "Fridge", value: UNIT_APPLIANCES.FRIDGE },
  { name: "Stove", value: UNIT_APPLIANCES.STOVE },
  { name: "Range Hood", value: UNIT_APPLIANCES.RANGEHOOD },
  { name: "Dishwasher", value: UNIT_APPLIANCES.DISHWASHER },
  { name: "Microwave", value: UNIT_APPLIANCES.MICROWAVE },
  { name: "In-Unit Washer", value: UNIT_APPLIANCES.IN_UNIT_WASHER },
  { name: "In-Unit Dryer", value: UNIT_APPLIANCES.IN_UNIT_DRYER },
  { name: "Wine Fridge", value: UNIT_APPLIANCES.WINE_FRIDGE },
  { name: "Dehumidifier", value: UNIT_APPLIANCES.DEHUMIDIFIER },
  { name: "FirePlace Electric", value: UNIT_APPLIANCES.FIREPLACE_ELECTRIC },
  { name: "FirePlace Gas", value: UNIT_APPLIANCES.FIREPLACE_GAS },
  { name: "Jacuzzi", value: UNIT_APPLIANCES.JACUZZI }
]
